var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share Course"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "youtube 1",
    clipPath: "url(#clip0_2400_2617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5879 19.199C33.3574 18.3422 32.6819 17.6668 31.8252 17.4361C30.2602 17.0078 23.9998 17.0078 23.9998 17.0078C23.9998 17.0078 17.7396 17.0078 16.1745 17.4198C15.3344 17.6504 14.6424 18.3423 14.4118 19.199C14 20.7639 14 24.0094 14 24.0094C14 24.0094 14 27.2713 14.4118 28.8199C14.6425 29.6765 15.3179 30.352 16.1747 30.5827C17.7561 31.011 24 31.011 24 31.011C24 31.011 30.2602 31.011 31.8252 30.5991C32.682 30.3685 33.3574 29.693 33.5881 28.8364C33.9999 27.2713 33.9999 24.0259 33.9999 24.0259C33.9999 24.0259 34.0164 20.7639 33.5879 19.199Z",
    fill: "#4E5566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0057 27.0084L27.2116 24.0101L22.0057 21.0117V27.0084Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_2617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeLogo);
export default __webpack_public_path__ + "static/media/YouTubeLogo.a248a0a6bcbaa2b26a900abf0c50ac06.svg";
export { ForwardRef as ReactComponent };